import axios from 'axios'

export const getAllRequests = locations => {
    return axios.post('/ajax/request/list', { locations })
}
export const getRequestsDetails = requestIds => {
    return axios.post('/ajax/request/list-request-details', { requestIds })
}
export const getPMRequests = locations => {
    return axios.post('/ajax/request/list-PMs', { locations })
}
export const createEquipmentRequest = data => {
    return axios.post('/ajax/request/equipment', data)
}
export const listRepairRequestsForEquipment = (equipmentId, companyId) => {
    return axios.post('/ajax/request/list-equipment-repairs', {
        equipmentId,
        companyId,
    })
}
export const listPMRequestsForEquipment = (equipmentId, companyId) => {
    return axios.post('/ajax/request/list-equipment-PMs', {
        equipmentId,
        companyId,
    })
}
export const listEstimateRequestsForEquipment = (equipmentId, companyId) => {
    return axios.post('/ajax/request/list-equipment-estimates', {
        equipmentId,
        companyId,
    })
}
export const requestUsedEquipment = data => {
    return axios.post('/ajax/request/used-equipment', data)
}
export const createPartsRequest = data => {
    return axios.post('/ajax/request/parts', data)
}
export const createRentalRequest = data => {
    return axios.post('/ajax/request/rental', data)
}
export const getUsedEquipmentDetails = (equipmentId, requestUUID) => {
    return axios.get(
        '/ajax/equipment/details?id=' +
            equipmentId +
            '&requestUUID=' +
            requestUUID,
    )
}
export const searchUsedEquipment = data => {
    return axios.post('/ajax/equipment/search', data)
}
export const missingEquipmentImageLog = data => {
    return axios.post('/ajax/equipment/missing-image', data)
}
export const createServiceRequest = data => {
    return axios.post('/ajax/request/service', data)
}
export const getSingleRequest = (requestId, requestType) => {
    return axios.get(
        '/ajax/request/detail/' + requestId + '?requestType=' + requestType,
    )
}

export const getServiceEstimate = estimateId => {
    return axios.get('/ajax/estimate/detail/' + estimateId)
}

export const uploadFile = data => {
    return axios.post('/ajax/request/upload', data)
}

export const estimateApproval = data => {
    return axios.post('/ajax/estimate/approval', data)
}

export const updatePONumber = data => {
    return axios.put('/ajax/request/purchase-order', data)
}
